export default __webpack_public_path__ + "static/media/a017-line3.e4b8a2ae.svg";